import { ControllerFlowAPI } from '@wix/yoshi-flow-editor';
import {
  addOnLoginHandler,
  IOnLoginHandlerPriority,
} from '../../GeneralDataProvider/helpers/onLogin';
import { userProviderPropsMap } from '../userProviderPropsMap';
import {
  isParticipantPageAvailable,
  navigateToProgramPage,
} from '../../Location/helpers/generateLinksToProgramForList';
import { getChallengeSlugFromLocation } from '../../Location/locationProviderPropsMap';
import { isUserJoinedAlready } from './userTypeHandlers';

export default function handleUserAfterLogin() {
  addOnLoginHandler({
    priority: IOnLoginHandlerPriority.FIRST,
    handler: async (flowAPI: ControllerFlowAPI) => {
      const userProvider = await userProviderPropsMap(flowAPI);
      const user = await userProvider.updateParticipant();

      await userProvider.updateParticipantLockedState();

      if (await isParticipantPageAvailable(flowAPI)) {
        const isViewer = flowAPI.environment.isViewer;
        const challengeId = getChallengeSlugFromLocation(flowAPI);
        const isChallengePage = location.href.includes('challenge-page');

        if (
          isViewer &&
          challengeId &&
          isChallengePage &&
          isUserJoinedAlready(user.userType)
        ) {
          flowAPI.controllerConfig.setProps({
            isForcedBlankPage: true,
          });
          await navigateToProgramPage(flowAPI, {
            challengeId,
            isParticipant: true,
          });
        }
      }
    },
  });
}
